<template>
    <el-dialog
        v-drag
        class="record-dialog"
        title="是否零担专线编辑记录"
        :visible.sync="visible"
        :close-on-click-modal="false"
        width="800px"
        :before-close="close">
        <el-table :data="tableData" v-loading="loading" border style="width: 100%" max-height="500px">
            <el-table-column show-overflow-tooltip prop="logType_" label="场景" width="180"></el-table-column>
            <el-table-column
                show-overflow-tooltip
                prop="isSelfManage_"
                label="是否零担专线"
                width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateUserName" label="编辑人" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateTime" label="编辑时间"></el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="btnLoading" @click="close">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { editRecord } from '../../../../../../api/regularRoute.js'
import { dictWithUrl } from '@/components/lots/api'
export default {
    data() {
        return {
            visible: false,
            btnLoading: false,
            loading: false,
            tableData: [],
            dict: {},
            pageNo: 1,
            pageSize: 10,
            total: 0,
            commonRouteId: '',
        }
    },
    created() {},
    methods: {
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        getList() {
            this.loading = true
            editRecord({
                commonRouteId: this.commonRouteId,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderBy: 'create_time',
                orderByType: 'desc',
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.total = res.data.totalCount || 0
                        this.tableData = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                isSelfManage_: this.dict['SRM_YES_OR_NO'][v.isSelfManage],
                                logType_: v.logType === '1' ? '编辑线路' : '新增线路',
                            }
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        open(commonRouteId) {
            this.visible = true
            this.commonRouteId = commonRouteId
            this.getList()
        },
        close() {
            this.pageNo = 1
            this.pageSize = 10
            this.tableData = []
            this.visible = false
        },
    },
    mounted() {
        dictWithUrl('SRM_YES_OR_NO').then(res => {
            this.dict = res.data
        })
    },
}
</script>
<style lang="less" scoped>
.pagination {
    text-align: right;
    margin-top: 10px;
}
</style>
